/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Architect_Detail9Inputs */

const en_svc_automation_architect_detail9 = /** @type {(inputs: Svc_Automation_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triggers, steps, error handling, and notification paths.`)
};

const ar_svc_automation_architect_detail9 = /** @type {(inputs: Svc_Automation_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المشغلات والخطوات ومعالجة الأخطاء ومسارات الإشعارات.`)
};

const bn_svc_automation_architect_detail9 = /** @type {(inputs: Svc_Automation_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ট্রিগার, স্টেপ, এরর হ্যান্ডলিং ও নোটিফিকেশন পাথ।`)
};

const de_svc_automation_architect_detail9 = /** @type {(inputs: Svc_Automation_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auslöser, Schritte, Fehlerbehandlung und Benachrichtigungspfade.`)
};

const es_svc_automation_architect_detail9 = /** @type {(inputs: Svc_Automation_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desencadenantes, pasos, manejo de errores y rutas de notificación.`)
};

const fr_svc_automation_architect_detail9 = /** @type {(inputs: Svc_Automation_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déclencheurs, étapes, gestion des erreurs et chemins de notification.`)
};

const pt_svc_automation_architect_detail9 = /** @type {(inputs: Svc_Automation_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gatilhos, etapas, tratamento de erros e caminhos de notificação.`)
};

const zh_svc_automation_architect_detail9 = /** @type {(inputs: Svc_Automation_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`触发器、步骤、错误处理和通知路径。`)
};

const tr_svc_automation_architect_detail9 = /** @type {(inputs: Svc_Automation_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetikleyiciler, adımlar, hata yönetimi ve bildirim yolları.`)
};

const ru_svc_automation_architect_detail9 = /** @type {(inputs: Svc_Automation_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Триггеры, шаги, обработка ошибок и пути уведомления.`)
};

const pl_svc_automation_architect_detail9 = /** @type {(inputs: Svc_Automation_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyzwalacze, kroki, obsługa błędów i ścieżki powiadomień.`)
};

/**
* | output |
* | --- |
* | "Triggers, steps, error handling, and notification paths." |
*
* @param {Svc_Automation_Architect_Detail9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_architect_detail9 = /** @type {((inputs?: Svc_Automation_Architect_Detail9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Architect_Detail9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_architect_detail9(inputs)
	if (locale === "bn") return bn_svc_automation_architect_detail9(inputs)
	if (locale === "de") return de_svc_automation_architect_detail9(inputs)
	if (locale === "es") return es_svc_automation_architect_detail9(inputs)
	if (locale === "fr") return fr_svc_automation_architect_detail9(inputs)
	if (locale === "pt") return pt_svc_automation_architect_detail9(inputs)
	if (locale === "zh") return zh_svc_automation_architect_detail9(inputs)
	if (locale === "tr") return tr_svc_automation_architect_detail9(inputs)
	if (locale === "ru") return ru_svc_automation_architect_detail9(inputs)
	if (locale === "pl") return pl_svc_automation_architect_detail9(inputs)
	return en_svc_automation_architect_detail9(inputs)
});
export { svc_automation_architect_detail9 as "svc_automation_ARCHITECT_detail" }